import { useSettings } from "../../context/SettingsContext";
import { API } from "../../lib/api";

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-hidden="true">
    <rect x="1" y="1" width="62" height="62" rx="14" fill="#0A0A0C" stroke="#DC2626" strokeWidth="2" />
    <path d="M8 46h48" stroke="#FACC15" strokeWidth="3" strokeDasharray="6 4" />
    <path d="M10 38V26h14l6 6h4l2-10h6l-2 16H10z" fill="#DC2626" />
    <path d="M36 22l14-8" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
    <path d="M50 14v8l-3 3" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    <rect x="13" y="28" width="7" height="5" rx="1" fill="#0A0A0C" />
    <circle cx="17" cy="39" r="4" fill="#fff" stroke="#0A0A0C" strokeWidth="2" />
    <circle cx="33" cy="39" r="4" fill="#fff" stroke="#0A0A0C" strokeWidth="2" />
  </svg>
);

export const Logo = ({ compact = false }) => {
  const { settings } = useSettings();
  if (settings.has_logo) {
    return (
      <span className="flex items-center gap-3">
        <img src={`${API}/public/logo?v=${settings.logo_version || 0}`} alt={settings.business_name} className="h-10 w-auto max-w-[160px] object-contain" />
        {!compact && <span className="sr-only">{settings.business_name}</span>}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      <span className="leading-none">
        <span className="block font-display text-lg sm:text-xl font-extrabold uppercase tracking-tight text-white">Tow Truck</span>
        <span className="block text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.2em] text-[#FACC15]">& Roadside Assistance</span>
      </span>
    </span>
  );
};
